/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable react/no-unescaped-entities */
import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate, useLocation } from "react-router-dom";
import notifications from "../../assets/json/notifications";
import message from "../../assets/json/message";
import ProfileModelPopup from "../../components/modelpopup/ProfileModelPopup";
import NotificationPopup from "../pages/hms/components/popups/notificationPopup";
import VersionNotificationModal from "../pages/hms/components/popups/VersionNotificationModal";
import LockScreenModal from "../pages/hms/components/popups/LockScreenModal";
import { Globe } from "react-feather";
import CryptoJS from "crypto-js";
import { renderDate } from "../pages/hms/utils/dateFormatter";
import moment from "moment";
import axios from "axios";
import useVersionChecker from "../../hook/VersionChecker";
import {
  Applogo,
  Avatar_02,
  Avatar_01,
  headerlogo,
  lnEnglish,
  lnFrench,
  lnGerman,
  lnSpanish,
} from "../../Routes/ImagePath";
import { FaRegBell, FaRegComment } from "react-icons/fa";
import { useHospitalityData } from "../context/HospitalityContext";
import { useTranslation } from "react-i18next";
import i18n from "../../i18n";
import ProfileMenu from "./ProfileMenu"; // Import the new ProfileMenu component

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const data = notifications.notifications;
  const datas = message.message;
  const [notification, setNotifications] = useState(false);
  const [flag, setflag] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [profile, setProfile] = useState(false);
  const [flagImage, setFlagImage] = useState(lnEnglish);
  const [isLocked, setIsLocked] = useState(false);
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const cdnUrl = process.env.REACT_APP_CDN_URL;
  const profilePic = localStorage.getItem("profilepic");
  const submitButtonRef = useRef(null);
  const [isFocused, setIsFocused] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const dropdownMenuRef = useRef(null);
  const [showPopup, setShowPopup] = useState(false);
  const secretKey = process.env.REACT_APP_ENCRYPTION_SECRET_KEY || "abde100199199111";
  const { hospitalityData, dateformat, loading, reservationLoading } = useHospitalityData();
  const businessdate = localStorage.getItem("business_date");
  const business_date = moment(businessdate).format("Do MMMM YYYY");
  const isUpdateAvailable = useVersionChecker();
  const [showReload, setShowReload] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const isLockedFromStorage = localStorage.getItem("isLocked") === "true";
    if (isLockedFromStorage && !isLocked) {
      setIsLocked(true);
      console.log("Restored lock state from localStorage:", isLockedFromStorage);
    }
  }, []);

  useEffect(() => {
    if (isUpdateAvailable) {
      setShowReload(true);
    }
  }, [isUpdateAvailable]);

  const handleReload = () => {
    window.location.reload(true);
  };

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setFlagImage(
      lng === "en"
        ? lnEnglish
        : lng === "fr"
        ? lnFrench
        : lng === "es"
        ? lnSpanish
        : lnGerman
    );
    if (submitButtonRef.current) submitButtonRef.current.click();
  };

  const refinedData = hospitalityData.map((reservation) => ({
    id: reservation.resNo || "N/A",
    guestName: reservation.guestName || "Unknown",
    pax: reservation.pax || 0,
    expectedTime: reservation.expectedTime || "N/A",
    checkinDate: renderDate(reservation.checkinDate) || "N/A",
    checkoutDate: renderDate(reservation.checkoutDate) || "N/A",
    bookingStatus:
      reservation.bookingStatus === "checked_in"
        ? t("In House")
        : reservation.bookingStatus || "Unknown",
    phone: reservation.phone || "N/A",
    email: reservation.email || "N/A",
    roomNumbers: reservation.roomNumbers || "N/A",
    mealPlan: reservation.mealPlan || "N/A",
    roomTypes: reservation.roomTypes || "N/A",
    bookingSource: reservation.bookingSource || "N/A",
    bookingID: reservation.bookingID,
    encryptedId: CryptoJS.AES.encrypt(
      reservation.bookingID.toString(),
      secretKey
    ).toString(),
  }));

  const handleInputChange = (e) => {
    const value = e.target.value;
    setSearchText(value);
    if (value) {
      const filtered = refinedData.filter(
        (item) =>
          item.guestName.toLowerCase().includes(value.toLowerCase()) ||
          item.phone.toLowerCase().includes(value.toLowerCase())
      );
      setSuggestions(filtered);
    } else {
      setSuggestions([]);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        !event.target.closest(".search-input") &&
        !event.target.closest(".suggestions-container")
      ) {
        setIsFocused(false);
        setSuggestions([]);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLogout = () => {
    if (submitButtonRef.current) submitButtonRef.current.click();
    localStorage.clear();
    sessionStorage.clear();
    delete axios.defaults.headers.common["Authorization"];
    navigate(baseUrl);
  };

  const handlesidebar = () => document.body.classList.toggle("mini-sidebar");
  const onMenuClik = () => document.body.classList.toggle("slide-nav");
  const toggleDropdown = () => {
    setIsOpen(!isOpen);
    setNotifications(false);
    setProfile(false);
    setflag(false);
  };
  const handleNotification = () => {
    setNotifications(!notification);
    setflag(false);
    setIsOpen(false);
    setProfile(false);
  };
  const handleProfile = () => {
    setProfile(true);
    setNotifications(false);
    setflag(false);
    setIsOpen(false);
  };
  const Credencial = localStorage.getItem("credencial");
  const Value = JSON.parse(Credencial);
  const UserName = Value?.email?.split("@")[0];
  const ProfileName = localStorage.getItem("username");
  const useremail = localStorage.getItem("useremail");
  const gender = localStorage.getItem("gender");
  const handleAccountClick = () => {
    if (submitButtonRef.current) submitButtonRef.current.click();
    setTimeout(() => navigate("/hospitality/account-setting"), 300);
  };
  const handleApiClick = () => {
    if (submitButtonRef.current) submitButtonRef.current.click();
    setTimeout(() => navigate("/hospitality/property-configuration"), 300);
  };
  const handleManageOrgClick = () => {
    if (submitButtonRef.current) submitButtonRef.current.click();
    setTimeout(() => navigate("/hospitality/manage-property"), 300);
  };
  const handleLockScreenClick = () => {
    if (submitButtonRef.current) submitButtonRef.current.click();
    localStorage.setItem("isLocked", "true");
    setIsLocked(true);
    console.log("Lock screen activated");
  };
  const handleUnlock = () => {
    localStorage.removeItem("isLocked");
    setIsLocked(false);
    console.log("Lock screen unlocked");
  };

  return (
    <div
      className="header stayx-global-header"
      style={{
        right: "0px",
        background: "linear-gradient(90deg, #07113f 0%, #0b1958 58%, #07113f 100%)",
        borderBottom: "1px solid rgba(255,255,255,0.10)",
        boxShadow: "0 4px 18px rgba(3, 10, 40, 0.18)",
      }}
    >
      <div
        className="header-left"
        style={{
          display: "flex",
          alignItems: "center",
          borderRight: "1px solid rgba(255,255,255,0.08)",
          background: "rgba(4, 12, 48, 0.28)",
        }}
      >
        <Link to="/hospitality/" className="logo">
          <img src={headerlogo} width={150} height={50} alt="img" />
        </Link>
        <Link to="/hospitality/" className="logo2">
          <img src={Applogo} width={40} height={40} alt="img" />
        </Link>
      </div>
      <div
        className="header-container"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "0 16px 0 24px",
          height: "100%",
          minWidth: 0,
        }}
      >
        <div
          style={{
            position: "relative",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flex: "0 1 460px",
            width: "100%",
            maxWidth: "460px",
            margin: "0 auto",
          }}
        >
          <form
            style={{ display: "flex", alignItems: "center", position: "relative", width: "100%" }}
            onSubmit={(e) => e.preventDefault()}
          >
            <input
              className="form-control search-input"
              type="text"
              placeholder={t("Search")}
              onFocus={() => setIsFocused(true)}
              onBlur={() => setTimeout(() => !suggestions.length && setIsFocused(false), 150)}
              onChange={handleInputChange}
              value={searchText}
              style={{
                width: "100%",
                height: "32px",
                color: "#f8fafc",
                padding: "0 38px 0 13px",
                borderRadius: "8px",
                border: isFocused
                  ? "1px solid rgba(147, 197, 253, 0.95)"
                  : "1px solid rgba(148, 163, 184, 0.45)",
                boxShadow: isFocused
                  ? "0 0 0 3px rgba(59, 130, 246, 0.12)"
                  : "inset 0 1px 0 rgba(255,255,255,0.04)",
                background: "rgba(20, 52, 145, 0.72)",
                transition: "border-color 160ms ease, box-shadow 160ms ease, background 160ms ease",
              }}
              disabled={isLocked}
            />
          </form>
          {suggestions.length > 0 && !isLocked && (
            <div
              className="suggestions-container"
              style={{
                position: "absolute",
                top: "100%",
                left: "0",
                width: "100%",
                height: "80vh",
                backgroundColor: "#fff",
                border: "1px solid #ccc",
                borderRadius: "8px",
                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                zIndex: "1000",
                overflow: "hidden",
                maxHeight: "60vh",
                overflowY: "auto",
              }}
            >
              {suggestions.map((item) => (
                <div
                  key={item.id}
                  className=" Skinner-item"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "15px 20px",
                    borderBottom: "1px solid #eee",
                    cursor: "pointer",
                    backgroundColor: "#fff",
                    transition: "background-color 0.2s",
                    minHeight: "80px",
                  }}
                  onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#f5f5f5")}
                  onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#fff")}
                  onClick={() => {
                    setSearchText(item.guestName);
                    setSuggestions([]);
                  }}
                >
                  <Link
                    to={`/hospitality/reservation-details/${item.encryptedId}`}
                    style={{ textDecoration: "none", color: "inherit", flex: 1 }}
                  >
                    <div style={{ flex: 1 }}>
                      <strong style={{ fontSize: "16px", color: "#333" }}>{item.guestName}</strong>
                      <div style={{ fontSize: "13px", color: "#666", marginTop: "5px" }}>
                        {t("Check-in")}: {item.checkinDate} | {t("Check-out")}: {item.checkoutDate}
                      </div>
                      <div style={{ fontSize: "13px", color: "#666", marginTop: "5px" }}>
                        {t("Room(s)")}: {item.roomNumbers} | {t("Meal Plan")}: {item.mealPlan}
                      </div>
                      <span
                        className={`colored-box status-box ${
                          item.bookingStatus === "reserved"
                            ? "bg-primary"
                            : item.bookingStatus === t("In House")
                            ? "bg-success"
                            : item.bookingStatus === "checked_out"
                            ? "bg-secondary"
                            : item.bookingStatus === "cancelled"
                            ? "bg-danger"
                            : "bg-default"
                        }`}
                        style={{
                          display: "inline-block",
                          padding: "4px 12px",
                          borderRadius: "4px",
                          color: "#fff",
                          fontSize: "12px",
                          fontWeight: "500",
                          marginTop: "8px",
                          textTransform: "capitalize",
                        }}
                      >
                        {item.bookingStatus}
                      </span>
                    </div>
                  </Link>
                  <div style={{ textAlign: "right", fontSize: "13px", color: "#666" }}>
                    <div style={{ marginBottom: "5px" }}>
                      <i className="fa fa-phone" style={{ marginRight: "6px", color: "#888" }} />
                      {item.phone}
                    </div>
                    <div>
                      <i className="fa fa-envelope" style={{ marginRight: "6px", color: "#888" }} />
                      {item.email}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
        <li className="nav-item dropdown has-arrow flag-nav" style={{ display: "none" }}>
          <Link
            className="nav-link dropdown-toggle"
            data-bs-toggle="dropdown"
            to="#"
            role="button"
            onClick={() => isLocked && handleLockScreenClick()}
          >
            <img src={flagImage} alt="Flag" height="20" /> {t(i18n.language)}
          </Link>
          <div className="dropdown-menu dropdown-menu-right">
            <Link
              to="#"
              className="dropdown-item"
              onClick={() => !isLocked && changeLanguage("en")}
            >
              <img src={lnEnglish} alt="Flag" height="16" /> {t("English")}
            </Link>
            <Link
              to="#"
              className="dropdown-item"
              onClick={() => !isLocked && changeLanguage("fr")}
            >
              <img src={lnFrench} alt="Flag" height="16" /> {t("French")}
            </Link>
            <Link
              to="#"
              className="dropdown-item"
              onClick={() => !isLocked && changeLanguage("es")}
            >
              <img src={lnSpanish} alt="Flag" height="16" /> {t("Spanish")}
            </Link>
            <Link
              to="#"
              className="dropdown-item"
              onClick={() => !isLocked && changeLanguage("de")}
            >
              <img src={lnGerman} alt="Flag" height="16" /> {t("German")}
            </Link>
          </div>
        </li>
        <div
          style={{
            background: "rgba(37, 99, 235, 0.86)",
            color: "#ffffff",
            fontSize: "13px",
            fontWeight: 700,
            letterSpacing: "-0.01em",
            padding: "6px 12px",
            textAlign: "center",
            borderRadius: "8px",
            position: "absolute",
            top: "10px",
            right: "205px",
            border: "1px solid rgba(147, 197, 253, 0.30)",
            boxShadow: "0 3px 10px rgba(2, 8, 38, 0.18)",
            whiteSpace: "nowrap",
          }}
        >
          {business_date}
        </div>
        <div
          className="profile-section"
          style={{
            textAlign: "right",
            marginLeft: "12px",
            paddingLeft: "12px",
            borderLeft: "1px solid rgba(255,255,255,0.10)",
          }}
        >
          <li className="nav-item dropdown has-arrow main-drop">
            <Link
              to="#"
              className="dropdown-toggle nav-link"
              onClick={(event) => {
                event.preventDefault();
                if (!isLocked) handleProfile();
              }}
            >
              <span className="user-img me-1">
                <div className="profile-image">
                  <img
                    src={
                      profilePic && profilePic.trim() !== "" && profilePic !== "null"
                        ? `${cdnUrl}/${profilePic}`
                        : gender === "male"
                        ? Avatar_02
                        : Avatar_01
                    }
                    alt={t("User Avatar")}
                    className="user-avatar"
                    style={{
                      width: "40px",
                      height: "40px",
                      borderRadius: "50%",
                      objectFit: "cover",
                      border: "2px solid rgba(255,255,255,0.78)",
                      boxShadow: "0 0 0 2px rgba(96,165,250,0.28), 0 4px 10px rgba(0,0,0,0.20)",
                    }}
                  />
                </div>
              </span>
            </Link>
          </li>
        </div>
      </div>
      <ProfileMenu
        isOpen={profile}
        onClose={() => setProfile(false)}
        profilePic={profilePic}
        gender={gender}
        ProfileName={ProfileName}
        useremail={useremail}
        flagImage={flagImage}
        isLocked={isLocked}
        showPopup={showPopup}
        setShowPopup={setShowPopup}
        handleLockScreenClick={handleLockScreenClick}
        handleLogout={handleLogout}
        handleAccountClick={handleAccountClick}
        handleApiClick={handleApiClick}
        handleManageOrgClick={handleManageOrgClick}
        changeLanguage={changeLanguage}
      />
      <LockScreenModal visible={isLocked} onUnlock={handleUnlock} />
      {showReload && <VersionNotificationModal visible={showReload} />}
      <div className="dropdown mobile-user-menu">
        <Link
          to="#"
          className="nav-link dropdown-toggle"
          data-bs-toggle="dropdown"
          aria-expanded="false"
          onClick={() => isLocked && handleLockScreenClick()}
        >
          <i className="fa fa-ellipsis-v" />
        </Link>
        <div className="dropdown-menu dropdown-menu-end dropdown-menu-right">
          <Link
            className="dropdown-item"
            to="/profile"
            onClick={() => isLocked && handleLockScreenClick()}
          >
            {t("My Profile")}
          </Link>
          <Link
            className="dropdown-item"
            to="/hospitality/manage-property"
            onClick={() => isLocked && handleLockScreenClick()}
          >
            {t("Settings")}
          </Link>
          <Link className="dropdown-item" to="#" onClick={() => !isLocked && handleLogout()}>
            {t("Logout")}
          </Link>
          <Link
            className="dropdown-item"
            to="#"
            onClick={() => !isLocked && handleLockScreenClick()}
          >
            {t("Lock Screen")}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Header;